import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const RenderEmptyState = ({
  icon = 'hicon-eye-open',
  text = 'No data detected for the current filter selections.',
} = {}) => (
  <div className="card-box-empty">
    <i className={cx('card-box-empty__icon', icon)} />
    <div className="card-box-empty__text">{text}</div>
  </div>
);

RenderEmptyState.propTypes = {
  icon: T.string,
  text: T.string,
};
export default RenderEmptyState;
